import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style as StatusBarStyle } from '@capacitor/status-bar';
import { setNavigationBarColor } from '@/services/app/navigation-bar.service';
import { useThemeConfig } from '@/components/ui/theme-config-provider';
import { isHexColorDark } from '@/utils/theme';

/**
 * Sync system status and navigation bars with the current theme.
 * La barra di navigazione è regolabile solo su Android.
 */
export const useSystemBars = () => {
  const { theme } = useThemeConfig();

  useEffect(() => {
    const bg = theme.primaryColor || theme.backgroundColor;
    const darkIcons = !isHexColorDark(bg);

    if (Capacitor.isPluginAvailable('StatusBar')) {
      StatusBar.setOverlaysWebView({ overlay: false });
      StatusBar.setBackgroundColor({ color: bg });
      StatusBar.setStyle({ style: darkIcons ? StatusBarStyle.Dark : StatusBarStyle.Light });
    }

    void setNavigationBarColor({ color: bg, darkButtons: darkIcons });
  }, [theme]);
};
